module.exports = __webpack_public_path__ + "static/media/second_white_strip.d746eba3.svg";